import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

const useSearchStore = create(
  persist(
    (set, get) => ({
      searchResults: null,
      selectedResult: null,
      isLoading: false,
      error: null,

      setSelectedResult: (result) => {
        set({ selectedResult: result });
      },

      search: async (query) => {
        set({ isLoading: true, error: null });
        try {
          const response = await api.post('/search/query', query);
          set({ 
            searchResults: response.data,
            isLoading: false,
            error: null
          });
          return response.data;
        } catch (error) {
          set({ 
            isLoading: false,
            error: error.response?.data?.message || 'Search failed'
          });
          throw error;
        }
      },

      clearSearch: () => {
        set({ 
          searchResults: null,
          selectedResult: null,
          error: null
        });
      }
    }),
    {
      name: 'search-storage',
      partialize: (state) => ({
        searchResults: state.searchResults,
        selectedResult: state.selectedResult
      })
    }
  )
);

export default useSearchStore; 